import type { LocationBrief } from '@/api/types'

/** Formatowanie danych w polskiej konwencji. */

const dateFormatter = new Intl.DateTimeFormat('pl-PL', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

const dateTimeFormatter = new Intl.DateTimeFormat('pl-PL', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

const currencyFormatter = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  maximumFractionDigits: 0,
})

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—'
  return dateFormatter.format(new Date(value))
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—'
  return dateTimeFormatter.format(new Date(value))
}

export function formatCurrency(value: number): string {
  return currencyFormatter.format(value)
}

/** Inicjały do awatara zastępczego, np. „Anna Kowalska” → „AK”. */
export function initials(fullName: string): string {
  return fullName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}

/** Powitanie zależne od pory dnia. */
export function greeting(date = new Date()): string {
  const hour = date.getHours()
  if (hour < 5) return 'Dobranoc'
  if (hour < 18) return 'Dzień dobry'
  return 'Dobry wieczór'
}

/** Polska odmiana liczebników, np. 1 lekcja / 2 lekcje / 5 lekcji. */
export function plural(count: number, one: string, few: string, many: string): string {
  if (count === 1) return one
  const mod10 = count % 10
  const mod100 = count % 100
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
  return many
}

/** Ile nazw oddziałów pokazujemy, zanim reszta zamieni się w licznik. */
export const WIDOCZNE_ODDZIALY = 2

/**
 * Skrót listy oddziałów do jednego zdania.
 *
 * Komplet oddziałów czyta się jak u właścicielki — „Wszystkie oddziały”.
 * Dłuższa lista kończy się licznikiem, tak samo jak przy instrumentach:
 * pięć nazw w komórce tabeli i tak nikomu nic nie mówiło.
 *
 * `hasAll` liczy serwer. Przeglądarka nie zna liczby oddziałów szkoły, bo
 * administrator widzi wyłącznie swoje.
 */
export function podsumujOddzialy(
  locations: LocationBrief[],
  hasAll: boolean,
  limit = WIDOCZNE_ODDZIALY,
): string {
  if (hasAll) return 'Wszystkie oddziały'
  if (locations.length === 0) return '—'

  const nazwy = locations.map((item) => item.name)
  if (nazwy.length <= limit) return nazwy.join(', ')
  return `${nazwy.slice(0, limit).join(', ')} +${nazwy.length - limit}`
}
